module.exports = __webpack_public_path__ + "static/img/jj1.6f6fc99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/jj1.png
// module id = PXcM
// module chunks = 13